module.exports = "/images/quiz_card_default_background.png?7336bdcfa96733e99497e2c49eef5da9";